import 'owl.carousel';
import 'lazysizes';
import 'picturefill';
import 'ion-rangeslider';
import 'select2';
import '../../default/js/common/SwitchButton.plugin';
import searchbar from '../../default/js/homepage/searchbar.js';
import form from '../../default/js/modules/form';
import modalFunding from "../../default/js/modules/modal-infos-funding";
//import modal from "../../default/js/modules/modal";

$(document).ready(function () {

    searchbar();
    form();

    var haut = (window.innerHeight);
    if ( haut < 825 ) {
        $(".home-makers-aside").removeClass("d-lg-block d-xl-block")
        console .log(haut);
    }
    //owl-carousel--home
    $(".owl-carousel--home").owlCarousel({
        items: 1,
        dost: true,
        nav: true,
        rewind: true,
        lazyLoad: true,
        autoplay: true,
        autoplayTimeout: 8000,
        autoplayHoverPause: true,
        navText: ["<span class='icon-chevron-down'></span>","<span class='icon-chevron-right'></span>"]
    });

    let carousel = $('.owl-carousel--vehicleVo');
    carousel.on({
        'initialized.owl.carousel': function () {
            carousel.find('.item-vehicle').show();
        }
    }).owlCarousel({
        margin: 10,
        dost: true,
        nav: false,
        responsive: {
            0: {
                items: 1,
                margin: 0
            },
            576: {
                items: 2,
                margin: 20
            },
            768: {
                items: 3,
                margin: 30
            },
            992: {
                items: 4,
                margin: 30
            }
        }
    });

    $.each($('.item-card--promo'), function(i,e) {
        var link = $(e).find('a').attr('href');
        $(e).on('click', function(elem) {
            window.location = link;
        });
    });

    // Lien sur l'item vehicule vers le DETANN, mais excluant les "button"
    $.each($('.item-vehicle'), function(i,e) {
        var link = $(e).find('a.item-vehicle__content__name').attr('href');
        $(e).on('click', function(e) {
            if(
                $(e.target).hasClass('btn') ||
                $(e.target).hasClass('btn-info-funding') ||
                $(e.target).parents('.btn').length > 0 ||
                $(e.target).hasClass('box-auto-i-div') ||  // i cetelem
                $(e.target).hasClass('box-auto-i-span')

            ) {
                e.preventDefault();
            } else {
                window.location = link;
            }
        });
    });


});


// WEBPACK FOOTER //
// ./app/Resources/assets/group/js/home.js